import { useState } from 'react';
import styled, { css } from 'styled-components';
import { ChevronDownIcon, ChevronRightIcon } from './icons';

const SectionPreTitle = styled.div(
  ({ theme }) => css`
    font-size: ${theme.fonts.sizes.h3};
    font-weight: 600;
  `
);
const SectionTitle = styled.h1`
  margin-bottom: 0;
`;

const SectionSubTitle = styled.div(
  ({ theme }) => css`
    font-size: ${theme.fonts.sizes.h6};
  `
);

type TSectionWrapperProps = {
  marginTop?: string;
};

const SectionWrapper = styled.div<TSectionWrapperProps>(
  ({ theme, marginTop = '40px' }: any) => css`
    border-top: ${theme.borders.light};
    padding-top: 22px;
    margin-top: ${marginTop};

    &:first-child {
      margin-top: 8px;
    }
  `
);

const SectionHeading = styled.h2(
  ({ theme }) => css`
    font-size: ${theme.fonts.sizes.h2};
    margin-bottom: 15px;
  `
);

const CollapsibleTitle = styled.h1(
  ({ theme }) => css`
    color: ${theme.buttons.primary.background};
    font-size: ${theme.fonts.sizes.h1};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
  `
);

const CollapsibleSection = ({
  title = '',
  expanded = false,
  children
}: any) => {
  const [collapsed, setCollapsed] = useState(!expanded);
  return (
    <SectionWrapper marginTop="1em">
      <CollapsibleTitle onClick={() => setCollapsed(!collapsed)}>
        {title}
        {collapsed ? (
          <ChevronRightIcon size="0.9em" />
        ) : (
          <ChevronDownIcon size="0.9em" />
        )}
      </CollapsibleTitle>
      {!collapsed && children}
    </SectionWrapper>
  );
};

export {
  CollapsibleSection,
  SectionPreTitle,
  SectionTitle,
  SectionSubTitle,
  SectionWrapper,
  SectionHeading
};
